import React from "react";
import { QrDesignName } from "widgets/grid/cells/QrDesignName";
import { DateColumn } from "widgets/grid/cells/DateColumn";
import { QrCodeDesignsActions, QrCodesActions } from "widgets/grid/cells/QrCodesDesignsActions";
import FilterHeader from "utils/columns/FilterHeader";
import { QrCodes } from "reducers/QrCodes";
import { QrDesigns } from "reducers/QrDesigns";
import { QrGeneratedFrom } from "widgets/grid/cells/QrGeneratedFrom";
import { TextOverflow } from "utils/common";

export const QR_CODES_DESIGNS_COLUMNS = [
	{
		key: "name",
		name: "Design Name",
		width: 325,
		resizable: true,
		cellClass:"link-cell fill-cell",
		getRowMetaData(data) {
			const { previewImageUrl, id } = data;
			return { previewImageUrl, id };
		},
		sortable:true,
		formatter: QrDesignName,
	},
	{
		key: "id",
		name: "ID",
		width: 180,
		resizable:false,
		sortable: true,
	},
	{
		key: "actions",
		name: "Actions",
		cellClass: "actions-cell",
		width: 150,
		getRowMetaData(data) {
			const { numQrCodes, libraryId, id, name } = data;
			return {
				numQrCodes,
				libraryId,
				id,
				designName: name,
			};
		},
		formatter: QrCodeDesignsActions,
		resizable: false,
		sortable: false,
	},
	{
		key: "numQrCodes",
		name: "QR Codes",
		width: 275,
	},
	{
		key: "dateLastUpdate",
		name: "Last Modified",
		formatter: DateColumn,
		sortable: true,
		filter: "Date",
		headerRenderer: (
			<FilterHeader
				Reducer = {QrDesigns}
				filterSelector = { state => state.qrDesigns.columnFilters.active.dateLastUpdate }
			/>
		),
	}
];

export const QR_CODES_COLUMNS = [
	{
		key: "name",
		name: "QR Code Name",
		width: 320,
		resizable: true,
		sortable: true,
		formatter: TextOverflow,
	},
	{
		key: "id",
		name: "ID",
		width: 180,
		resizable:false,
		sortable: true,
	},
	{
		key: "actions",
		name: "Actions",
		cellClass: "actions-cell",
		width: 150,
		getRowMetaData(data) {
			const { id, imageUrl } = data;
			return { id, imageUrl };
		},
		formatter: QrCodesActions,
		resizable: false,
		sortable: false,
	},
	{
		key: "defaultTargetUrl",
		name: "URL Destination",
		width: 250,
	},
	{
		key: "generatedFrom",
		name: "Generated From",
		width: 150,
		formatter: QrGeneratedFrom,
	},
	{
		key: "dateLastUpdate",
		name: "Last Modified",
		formatter: DateColumn,
		sortable: true,
		filter: "Date",
		headerRenderer: (
			<FilterHeader
				Reducer = {QrCodes}
				filterSelector = { state => state.qrCodes.columnFilters.active.dateLastUpdate }
			/>
		),
	}
];
